import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { getSocket } from '../context/socket';
import { useAuth } from '../context/AuthContext';

const DeleteCardPopup = ({ onCancel, cardDetails, togglePopup, cardId, boardId, onClose }) => {
    const socket = getSocket();
    const { userId } = useAuth();
    const [isDeleting, setIsDeleting] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const onError = (payload) => setError(payload?.message || 'Delete failed');
        socket?.on('error', onError);
        return () => socket?.off('error', onError);
    }, [socket]);

    const handleDelete = () => {
        setIsDeleting(true);
        setError('');
        const onDeleted = (payload) => {
            if (payload?.card_id === cardId) {
                socket.off('cardDeleted', onDeleted);
                onClose();
            }
        };
        socket.on('cardDeleted', onDeleted);
        socket.emit('deleteCard', {
            card_id: cardId,
            board_id: boardId,
            user_id: userId,
        });
        setIsDeleting(false);
    };

    return (
        <div className="popup-box popup-delete">
            <div className="popup-header d-flex justify-content-between align-items-center">
                <span>Delete Task</span>
                <Button icon="pi pi-times" className="p-button-text close-btn" onClick={() => togglePopup("delete")} />
            </div>
            <div className="popup-body">
                <p className="text-danger fw-bold mb-3">
                    Are you sure you want to delete this task named <strong>{cardDetails?.title}</strong>?
                    <br />
                    <span className="text-muted">This action is <strong>irreversible</strong>.
                    <br/> All associated data, comments, Images and attachment will be permanently deleted.</span>
                </p>
                {error && <p className="text-danger small">{error}</p>}
                <div className="d-flex justify-content-end">
                    <Button 
                        label="Cancel" 
                        className="border-0 py-1 px-3 me-2 p-button-secondary" 
                        onClick={() => onCancel()}
                        disabled={isDeleting}
                    />
                    <Button 
                        label="Yes, Delete" 
                        severity="danger" 
                        className="border-0 py-1 px-3" 
                        onClick={handleDelete} 
                        disabled={isDeleting}
                    />
                </div>
            </div>
        </div>
    );
};

export default DeleteCardPopup;
